import { useMemo } from 'react';

import { useGetMyOpportunitiesQuery, useGetOpportunitiesQuery } from '../api';
import { getLatestActivityDate, opportunityItemListTransformer } from '../helpers';

export function useMyOpportunityList() {
  const { data: opportunities, isLoading } = useGetMyOpportunitiesQuery();
  const transformed = useMemo(() => {
    return opportunities
      ?.map(opportunityItemListTransformer)
      ?.sort((a: any, b: any) => getLatestActivityDate(b) - getLatestActivityDate(a));
  }, [opportunities]);
  return { data: transformed, isLoading };
}

export function usePublishedOpportunityList() {
  const { data: opportunities, isLoading, isFetching } = useGetOpportunitiesQuery();
  const transformed = useMemo(() => opportunities?.map(opportunityItemListTransformer), [opportunities]);
  return { data: transformed, isLoading, isFetching };
}
